import { BaseContext } from '../../../utils/basecontext';
import { HttpClient } from '../../../utils/httpclient/httpclient';
import { POST, APIImpl } from '../api';
import { SubscriberValidationRequest } from './subscribervalidationrequest';

export class SubscriberValidationAPI extends APIImpl<SubscriberValidationRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/subscriber-validation
        return "subscriber-validation";
    }

    getRequestData()
    {
        return "msisdn=" + this.getRequest().getSubscriberValidationRequest().getMsisdn() +"&"+
               "language="+ this.getRequest().getSubscriberValidationRequest().getLanguage() +"&"+
               "clientTxnId="+ "1502035" +"&"+
               "type=CheckMsisdnSendOTP";
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationapi.tsx